import { Link } from "react-router-dom";
import { useIsMobile } from "../hooks/use-mobile";

function FooterButton({ title, url }: { title: string; url?: string }) {
	const isMobile = useIsMobile();
	let textClasses = isMobile ? "web-body-b1" : "web-body-b2";
	textClasses += " text-white opacity-" + (url ? "100" : "30");

	return url ? (
		<Link className={textClasses} to={url}>
			{title}
		</Link>
	) : (
		<p className={textClasses}>{title}</p>
	);
}

export default FooterButton;
